import Vue from "vue";
import Vuex from "vuex";

import labels from "./modules/labels";
import presets from "./modules/presets";
import documents from "./modules/documents";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    labels,
    presets,
    documents
  }
});
